import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentManuales } from '@environments/environment';
import { Alert } from '@app/_models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class ServicePropuesta {
    constructor(private http: HttpClient) 
    {
     }
    
    postPropuesta(json:any) {
        console.log("json",json)
        return this.http.post<any>(`https://wic.ifelse.com.ar:8000/propuesta`,json).pipe(map(res => res));
    }

    postPropuestaEmpleo(json:any){
        return this.http.post<any>(`${environmentManuales.apiUrl}/Employee/InsertOrUpdate`,json).pipe(map(res => res));
    }



}
